import React from "react";
import { ShieldCheck, ShieldAlert, ShieldQuestion, Share2, RotateCcw } from "lucide-react";
import { verifyCardUrl } from "../../lib/api";

export const LIGHT = {
  GREEN: { c: "#2CF6B3", icon: ShieldCheck, label: "Likely genuine" },
  AMBER: { c: "#FFB020", icon: ShieldQuestion, label: "Unsure — take care" },
  RED: { c: "#FF3D68", icon: ShieldAlert, label: "Likely AI or scam" },
};

export const VerdictCard = ({ jobId, v, onAgain }) => {
  const L = LIGHT[v.light] || LIGHT.AMBER;
  const share = async () => {
    const url = `${window.location.origin}/verify/r/${jobId}`;
    const text = `${v.light}: ${v.reason}\nTip: ${v.tip}\nCheck another: ${window.location.origin}/verify`;
    try { if (navigator.share) await navigator.share({ title: "Verify Bar", text, url }); else { await navigator.clipboard.writeText(`${text}\n${url}`); } } catch (e) { /* share cancelled */ }
  };
  return (
    <div className="rounded-2xl border-2 p-5 space-y-3 bg-[#050b14]" style={{ borderColor: L.c, boxShadow: `0 0 40px ${L.c}33` }} data-testid="verify-verdict">
      <div className="flex items-center gap-3">
        <span className="w-14 h-14 rounded-full flex items-center justify-center shrink-0" style={{ background: L.c }}><L.icon className="w-8 h-8 text-[#030712]" /></span>
        <div>
          <p className="text-3xl font-black tracking-tight" style={{ color: L.c }} data-testid="verify-light">{v.light}</p>
          <p className="text-sm text-cyan-100/70">{L.label}</p>
        </div>
      </div>
      <p className="text-lg text-cyan-50 font-semibold" data-testid="verify-reason">{v.reason}</p>
      <ul className="space-y-1" data-testid="verify-signals">{(v.signals || []).map((s, i) => <li key={i} className="text-sm text-cyan-100/80">• {s}</li>)}</ul>
      <p className="text-sm rounded-xl px-3 py-2 bg-amber-400/10 border border-amber-400/40 text-amber-100" data-testid="verify-tip">Tip: {v.tip}</p>
      <p className="text-[11px] text-cyan-200/50">{v.disclaimer} · engines: {(v.engines || []).join(", ")}</p>
      <div className="flex flex-wrap gap-2">
        <button onClick={share} className="flex items-center gap-2 rounded-full px-4 py-2 bg-[#00F0FF] text-[#030712] font-bold" data-testid="verify-share-btn"><Share2 className="w-4 h-4" /> Forward to family</button>
        <a href={verifyCardUrl(jobId)} target="_blank" rel="noreferrer" className="rounded-full px-4 py-2 border border-cyan-400/50 text-cyan-200" data-testid="verify-card-link">Card image</a>
        {onAgain && <button onClick={onAgain} className="flex items-center gap-2 rounded-full px-4 py-2 border border-cyan-400/50 text-cyan-200" data-testid="verify-again-btn"><RotateCcw className="w-4 h-4" /> Check another</button>}
      </div>
    </div>
  );
};
